import TabPanel, { Item } from "devextreme-react/tab-panel";
import AttendanceSettingForm from "./AttendanceSettingForm";

const SettingPage = () => {
  return (
    <div>
      <TabPanel>
        <Item title="Attendance">
          <AttendanceSettingForm />
        </Item>
      </TabPanel>
    </div>
  );
};

export default SettingPage;
